"use client";

import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToProtectYourRoof() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235675" id="ready-for-better-it" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-background to-secondary/5 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default text-2xl md:text-4xl font-bold mb-8 text-foreground tracking-tight">
            Stop Fighting Your Tech. Start Growing Your Business.
          </h2>

          <div className="mb-12 md:mb-16">
            <Link to="tel:6059104836" className="inline-block transition-transform duration-300 hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-md">
              <span className="font-default text-[50px] sm:text-[60px] md:text-[80px] leading-none font-bold text-primary tracking-tighter drop-shadow-md">(605) 910-4836</span>
            </Link>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 shadow-xl shadow-primary/30 bg-primary text-primary-foreground hover:bg-primary/90 rounded-full">
              <Link to="tel:6059104836">
                <Phone className="mr-2 size-5" />
                Schedule Your Free Audit
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground rounded-full">
              <Link to="mailto:info@rapidtechworks.com">
                <Mail className="mr-2 size-5" />
                Email Our Team
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}